/**
 * Cart Share
 * Builds a Shopify cart permalink from the current cart and lets the
 * customer copy it or open their device's native share sheet.
 * Wire it up to any button with [data-cart-share-button].
 */
(function () {
  var COPIED_LABEL_MS = 2000;

  function buildCartUrl(cart) {
    if (!cart.items.length) return null;
    var pairs = cart.items
      .map(function (item) {
        return item.variant_id + ':' + item.quantity;
      })
      .join(',');
    return window.location.origin + '/cart/' + pairs + '?storefront=true';
  }

  function setStatus(button, message, isError) {
    var wrapper = button.closest('[data-cart-share]');
    var statusEl = wrapper && wrapper.querySelector('[data-cart-share-status]');
    if (!statusEl) return;
    statusEl.textContent = message;
    statusEl.classList.toggle('cart-share__status--error', !!isError);
  }

  function resetLabel(button) {
    var original = button.getAttribute('data-original-label');
    if (original) button.textContent = original;
  }

  function showCopiedFeedback(button) {
    if (!button.hasAttribute('data-original-label')) {
      button.setAttribute('data-original-label', button.textContent.trim());
    }
    button.textContent = button.getAttribute('data-copied-label') || 'Copied!';
    button.classList.add('cart-share__button--copied');
    window.clearTimeout(button._cartShareTimeout);
    button._cartShareTimeout = window.setTimeout(function () {
      resetLabel(button);
      button.classList.remove('cart-share__button--copied');
    }, COPIED_LABEL_MS);
  }

  async function copyToClipboard(url) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url);
      return;
    }
    var textarea = document.createElement('textarea');
    textarea.value = url;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  async function handleShareClick(button) {
    var response = await fetch('/cart.js');
    var cart = await response.json();
    var url = buildCartUrl(cart);

    if (!url) {
      setStatus(button, button.getAttribute('data-empty-label') || 'Your cart is empty.', true);
      return;
    }

    if (navigator.share) {
      try {
        await navigator.share({ url: url, title: document.title });
        setStatus(button, '');
        return;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
      }
    }

    try {
      await copyToClipboard(url);
      showCopiedFeedback(button);
      setStatus(button, button.getAttribute('data-copied-status') || 'Link copied to clipboard.');
    } catch (error) {
      setStatus(button, url);
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-share-button]');
    if (!button) return;
    event.preventDefault();
    handleShareClick(button);
  });
})();